import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Input from '../Global/Input';
import Button from '../Global/Button';

import FormValidator from '../../validation/validator';
import { notEmpty, validEmailFormat } from '../../validation/validationRules';
import { createValidationObject } from '../../helpers/validationHelpers';
import { sendContactRequest } from '../../store/actions/commonActions';

import TextArea from '../Global/TextArea';

class ContactForm extends Component {

    constructor(props) {
        super(props);

        this.initializeValidator();

        this.state = {
            name: '',
            nameVisited: '',
            title: '',
            titleVisited: false,
            content: '',
            contentVisited: false,
            email: '',
            emailVisited: false,
            firstSubmit: true,
            validation: this.validator.valid()
        }
    }

    render() {
        const { validation, name, nameVisited, title, titleVisited, content, contentVisited, email, emailVisited, firstSubmit } = this.state;
        const { sendingContactRequest } = this.props;

        const validationFields = createValidationObject(
            validation,
            firstSubmit,
            ['name', 'title', 'content', 'email'],
            [nameVisited, titleVisited, contentVisited, emailVisited]
        );
        return (
            <div className="contact-form">
                <h1 className="contact-form__title">
                    Kontaktirajte nas sa formom ispod!
                </h1>
                <Input
                    changeHandler={this.onChange}
                    blurHandler={this.onBlur}
                    inputInvalid={validationFields.name}
                    validationMessage={(validationFields.name ? validation.name.message : null)}
                    placeholder="Ime i prezime*"
                    label="Ime i prezime*"
                    name="name"
                    hasLabel={true}
                    inputClasses={`contact-form__input`}
                    containerClasses={`contact-form__input__container`}
                    value={name}
                    type="text"
                />
                <Input
                    changeHandler={this.onChange}
                    blurHandler={this.onBlur}
                    inputInvalid={validationFields.email}
                    validationMessage={(validationFields.email ? validation.email.message : null)}
                    placeholder="Email*"
                    label="Email*"
                    name="email"
                    hasLabel={true}
                    inputClasses={`contact-form__input`}
                    containerClasses={`contact-form__input__container`}
                    value={email}
                    type="email"
                />
                <Input
                    changeHandler={this.onChange}
                    blurHandler={this.onBlur}
                    inputInvalid={validationFields.title}
                    validationMessage={(validationFields.title ? validation.title.message : null)}
                    placeholder="Naslov*"
                    label="Naslov*"
                    name="title"
                    hasLabel={true}
                    inputClasses={`contact-form__input`}
                    containerClasses={`contact-form__input__container`}
                    value={title}
                    type="text"
                />
                <TextArea value={content} onChange={this.onChange} onBlur={this.onBlur} placeholder={`Sadržaj`} errorLabel={(validationFields.content ? validation.content.message : null)} name="content" id="content" label={`Sadržaj poruke*`} />
                <Button loading={sendingContactRequest} onClick={this.send} disabled={(!validationFields.isValid && !firstSubmit) || sendingContactRequest} classes="button--login contact-form__button" text={`Pošalji`} color="yellow" />

            </div>
        );
    }
    send = () => {
        this.setState({
            firstSubmit: false
        }, () => {
            const isValid = this.validateForm();
            if(isValid) {
                const { name, content, title, email } = this.state;
                const data = new FormData();
                data.append('name', name);
                data.append('title', title);
                data.append('content', content);
                data.append('email', email);

                this.props.sendContactRequest(data)
            }
        })
    }
    onChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            [`${event.target.name}Visited`]: true
        }, () => {
            this.validateForm();
        })
    }

    onBlur = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            [`${event.target.name}Visited`]: true
        }, () => {
            this.validateForm();
        })
    }

    initializeValidator = () => {
        this.validator = new FormValidator([
            notEmpty('name', 'Ime ne može ostati prazno!'),
            notEmpty('title', 'Naslov ne može biti prazan!'),
            notEmpty('content', 'Sadržaj ne može biti prazan!'),
            notEmpty('email', 'Email ne može biti prazan!'),
            validEmailFormat('email', 'Email format nije pravilan!')
        ]);
    }

    validateForm = () => {
        const validation = this.validator.validate(this.state);
        this.setState({
            validation: validation
        })
        return validation.isValid;
    }
}

const mapStateToProps = (state) => {
    return {
        sendingContactRequest: state.common.sendingContactRequest
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        sendContactRequest: (request) => { dispatch(sendContactRequest(request)) },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContactForm));